import { render } from "./BackHeader.vue?vue&type=template&id=1688d29c&scoped=true"
import script from "./BackHeader.vue?vue&type=script&lang=js"
export * from "./BackHeader.vue?vue&type=script&lang=js"

import "./BackHeader.vue?vue&type=style&index=0&id=1688d29c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1688d29c"]])

export default __exports__